module.exports = __webpack_public_path__ + "static/media/img-digital-sticker-vertical.8ce4cf47.pdf";